module.exports = __webpack_public_path__ + "img/add-photo.814a42d4.svg";